import {
  AfterViewInit,
  DestroyRef,
  Directive,
  ElementRef,
  inject,
  signal,
} from '@angular/core';

export const CARD_MAX_WIDTH = 518;
export const CARD_MIN_WIDTH = 416;

const GAP = 16;
const MAX_CARDS_PER_ROW = 3;

@Directive({
  selector: '[pmResponsiveCardGrid]',
  exportAs: 'responsiveCardGrid',
  standalone: true,
})
export class ResponsiveCardGridDirective implements AfterViewInit {
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly destroyRef = inject(DestroyRef);

  private resizeObserver: ResizeObserver | null = null;

  readonly cardsPerRow = signal(MAX_CARDS_PER_ROW);

  readonly containerMaxWidth = `${MAX_CARDS_PER_ROW * CARD_MAX_WIDTH + (MAX_CARDS_PER_ROW - 1) * GAP}px`;

  ngAfterViewInit(): void {
    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        this.updateCardsPerRow(entry.contentRect.width);
      }
    });

    this.destroyRef.onDestroy(() => {
      this.resizeObserver?.disconnect();
    });

    const el = this.elementRef.nativeElement;
    this.resizeObserver.observe(el);
    this.updateCardsPerRow(el.offsetWidth);
  }

  gridColumns(visibleItems: number): string {
    const cols = Math.min(this.cardsPerRow(), visibleItems);
    return `repeat(${Math.max(1, cols)}, minmax(0, ${CARD_MAX_WIDTH}px))`;
  }

  private updateCardsPerRow(containerWidth: number): void {
    const calculatedCards = Math.floor(
      (containerWidth + GAP) / (CARD_MIN_WIDTH + GAP),
    );
    this.cardsPerRow.set(
      Math.min(Math.max(1, calculatedCards), MAX_CARDS_PER_ROW),
    );
  }
}
